module.exports = __webpack_public_path__ + "SourceSans3-BoldIt.otf.364b2.woff";